export default __webpack_public_path__ + "static/media/SWT0680.34I-40882_-24195_0.69ff3a50.jpg";